import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import news from "../content/news.json";
import NewsCard from "../components/News/NewsCard";

const News = () => {
  const theme = useTheme();

  return (
    <Box sx={{ bgcolor: "background.default" }}>
      <Box
        sx={{
          px: { xs: 2, sm: 4 },
          py: { xs: 7, md: 10 },
          background: `linear-gradient(135deg, ${theme.palette.primary.dark}, ${theme.palette.primary.main})`,
          color: theme.palette.common.white,
          textAlign: "center",
        }}
      >
        <Chip
          label="Stories and updates"
          sx={{
            bgcolor: "rgba(255,255,255,0.1)",
            color: theme.palette.common.white,
            border: "1px solid rgba(255,255,255,0.2)",
            mb: 2,
            fontWeight: 800,
          }}
        />
        <Typography
          variant="h2"
          component="h1"
          sx={{
            fontFamily: "Georgia, 'Times New Roman', serif",
            fontStyle: "italic",
            fontWeight: 500,
            fontSize: { xs: "2.5rem", md: "4rem" },
          }}
        >
          News
        </Typography>
        <Typography
          sx={{
            maxWidth: 760,
            mx: "auto",
            mt: 2,
            color: "rgba(255,255,255,0.84)",
            lineHeight: 1.8,
            fontSize: { xs: "1rem", md: "1.08rem" },
          }}
        >
          Patient stories, hospital updates and reports from the clinical teams
          connected through the Cyrenaeus partnership.
        </Typography>
      </Box>

      <Box
        sx={{
          maxWidth: 1180,
          mx: "auto",
          px: { xs: 2, sm: 4 },
          py: 7,
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            md: "repeat(3, minmax(0, 1fr))",
          },
          gap: 2.5,
        }}
      >
        {news.map((article, index) => (
          <NewsCard headingLevel="h2" key={`${article.title}-${index}`} {...article} />
        ))}
      </Box>
    </Box>
  );
};

export default News;
